module.exports = __webpack_public_path__ + "img/tribunal.671a266e.jpeg";